import { Brand } from '@ui/brand';
import { Button, InputOtp } from '@heroui/react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useOtpResolver, useOtp } from '../../entites/authorization';
import { useAtomValue } from 'jotai/index';
import { fcmAtom } from '@app/atoms/app/fcm.atom.ts';

type Form = {
  code: string;
};

export const OtpForm = ({
  phone,
  onSuccess,
  onChangePhone,
}: {
  phone: string;
  onChangePhone: () => void;
  onSuccess: (accessToken: string) => void;
}) => {
  const { trigger, isMutating, counterTimer, isShowCounter, resetCountdown } =
    useOtp({ onSuccess });
  const resolver = useOtpResolver();

  const fcmToken = useAtomValue(fcmAtom);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm<Form>({ resolver });

  const onSubmit: SubmitHandler<Form> = async ({ code }) => {
    const localFcmToken = localStorage.getItem('fcmToken');
    trigger({ phone, code, fcmToken: fcmToken || localFcmToken || '' }).catch(
      () => setError('code', { type: 'server', message: 'Неверный код' })
    );
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="mt-12 flex flex-col items-center"
    >
      <div className="h-12">
        <Brand />
      </div>

      <h1 className="font-semibold text-xl text-[#222223] mt-12">
        Введите код из SMS
      </h1>

      <p className="mt-4 text-center text-sm text-[#60656C]">
        Код подтверждения отправлен на номер:
      </p>
      <p className="mt-1 text-center text-sm text-[#60656C]">{phone}</p>

      <InputOtp
        {...register('code')}
        length={4}
        classNames={{
          input: 'caret-transparent',
        }}
        autoFocus
        className="mt-8"
        placeholder="Номер телефона"
        size="lg"
        isInvalid={!!errors.code?.message}
        errorMessage={errors.code?.message}
        onComplete={() => handleSubmit(onSubmit)()}
      />

      {isShowCounter && (
        <p className="mt-8 text-[#60656C] text-sm text-center">
          Получить новый код через: {counterTimer}
        </p>
      )}

      {!isShowCounter && (
        <Button
          isLoading={isMutating}
          fullWidth
          variant="light"
          size="lg"
          color="primary"
          className="mt-8"
          onPress={resetCountdown}
        >
          Получить новый код
        </Button>
      )}

      <Button
        fullWidth
        variant="bordered"
        size="lg"
        className="mt-8"
        onPress={onChangePhone}
      >
        Изменить номер
      </Button>
    </form>
  );
};
